import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { PageBuilderData } from '@src/types/pageBuilder'

const useFetchPageBuilderBeginnersGuideIndexJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<PageBuilderData>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.PAGE_BUILDER_BEGINNERS_GUIDE_INDEX,
    deserialize: response => response
  })
}

export default useFetchPageBuilderBeginnersGuideIndexJson
